import { __assign } from "tslib";
import { Reducer } from '@ekuaibao/store';
import key from './key';
import { catchError } from '@ekuaibao/lib/lib/lib-util';
import { showMessage } from '@ekuaibao/show-util';
var reducer = new Reducer(key.ID, {});
reducer.handle(key.GET_CHANPAY_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.PUT_ACCOUNT_PERSON, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.GET_REFRESH_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.GET_BANK_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.GET_PROVINCES_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.GET_CITIES_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.GET_BRANCH_LIST, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.POST_CHANPAY_CARD, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
reducer.handle(key.POST_PAYMENT, catchError(function (state, action) {
    if (action.error) {
        showMessage.error(action.error.message);
    }
    return __assign({}, state);
}));
export default reducer;
